module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown",
    class: {
      'active': _vm.routeName.startsWith('clients_')
    }
  }, [(_vm.newClients) ? _c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "to": {
        name: 'clients_list'
      }
    }
  }, [_vm._v("Cadastros \n       "), (_vm.newClients) ? _c('span', {
    staticClass: "bell-badge"
  }, [_vm._v(_vm._s(_vm.newClients))]) : _vm._e()]) : _c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "to": {
        name: 'clients_list'
      }
    }
  }, [_vm._v("Cadastros \n     ")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v("Filtros:")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'clients_list',
        query: {
          period: 6
        }
      }
    }
  }, [_vm._v("Hoje")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'clients_list',
        query: {
          period: 5
        }
      }
    }
  }, [_vm._v("Ontem")])], 1), _vm._v(" "), (_vm.recentClients && _vm.recentClients.length > 0) ? [_c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v("Acessados recentemente:")]), _vm._v(" "), _vm._l((_vm.recentClients), function(c, i) {
    return _c('li', {
      key: i
    }, [_c('router-link', {
      staticClass: "font-12",
      attrs: {
        "to": {
          name: 'clients_details',
          params: {
            clientId: c.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "font-8 label",
      class: {
        'label-default': !c.status, 'label-warning': c.status == 0 && c.active == 1, 'label-danger': c.status == 2 || c.active == 0, 'label-success': c.status == 1 && c.active == 1
      },
      staticStyle: {
        "margin": "0 5px 0 -10px",
        "display": "inline-block"
      }
    }, [_vm._v("\n                    \n               ")]), _vm._v(" " + _vm._s(c.name) + "\n           ")])], 1)
  })] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e1b27ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/itens_menu/RegistrationsMenu.vue
// module id = 826
// module chunks = 2